import RelatorioMovimentacaoView from "../../components/estoque/RelatorioMovimentacaoView";

export default function RelatorioMovimentacaoEstoque() {
  return <RelatorioMovimentacaoView />;
}
